export default __filename;
angular
  .module(__filename, ['ui.router'])

  .factory(
    'stateParamsHelper',
    ngInject(($state, $stateParams, $location) => ({
      /*
    Does the given stateParam equal this value?
    @param {String} param
    @param {String} value
    @return {Boolean}
    */
      stateParamsContain: (param, value) => {
        if (typeof param !== 'string') {
          throw new Error('param must be a string');
        }
        if (typeof value !== 'string') {
          throw new Error('value must be a string');
        }

        if (Array.isArray($stateParams[param])) {
          return Array.from($stateParams[param]).includes(value);
        }
        return value === $stateParams[param];
      },

      /*
    If stateParam value already exists, remove it. Otherwise set new value and reload the page.
    @param {String} param
    @param {String|Date} [value] - if date will be converted to day string. if undefined will unset
    @returns {Promise} resolves after state reloads
    */
      toggleStateParam: (param, value) => {
        // sanitize date for url
        if (typeof param !== 'string') {
          throw new Error('param must be a string');
        }

        $stateParams[param] = $stateParams[param] === value ? undefined : value;

        return $state.go($state.current.name, $stateParams, {reload: true, inherit: false});
      },

      /*
    Directly set stateParam to whatever value is provided
    @param {String} param
    @param {String|Date} [value] - if date will be converted to day string. if undefined will unset
    @returns {Promise} resolves after state reloads
    */
      setStateParam: (param, value) => {
        // sanitize date for url
        if (value === null) {
          value = undefined;
        }
        if (typeof param !== 'string') {
          throw new Error('param must be a string');
        }

        $stateParams[param] = value;

        return $state.go($state.current.name, $stateParams, {reload: true, inherit: false});
      },

      /*
    Remove all query params (except foodhub slug) and reload the page.
    */
      clearQueryParams: () =>
        // remove all query params but keep url params
        $location.url($location.path()),
    })),
  );
